import { Info } from 'lucide-react';
import type { JSX, ReactNode } from 'react';
import styles from './dialogs.module.css';

/**
 * F100 (С-I, круги 3–5 гейта): причина выключенного действия в подвале диалога — подсказка, а не
 * третья кнопка: приглушённый тон, мелкий кегль и значок; слева, перед парой «Отмена» + действие.
 * Кнопка действия связывает её через `aria-describedby={id}` (STAITER_UI.md § 4.1). С `htmlFor`
 * подсказка — подпись поля: клик ставит курсор в поле, которое ушло из вида при прокрутке.
 */
export function FooterReason({
  id,
  htmlFor,
  children,
}: {
  id: string;
  htmlFor?: string;
  children: ReactNode;
}): JSX.Element {
  const content = (
    <>
      <Info size={14} aria-hidden="true" />
      {children}
    </>
  );
  return htmlFor ? (
    <label id={id} htmlFor={htmlFor} className={styles.footerReason}>
      {content}
    </label>
  ) : (
    <span id={id} className={styles.footerReason}>
      {content}
    </span>
  );
}
